export default __webpack_public_path__ + "static/media/yoga.055083d8.png";